import paper from "paper";
import { eachL, filterL, go, takeAll } from "fxjs/es";
import { getInternalAngle } from "./path_fns.js";

const getUnnecessaryCurve = (curve, len_limit, is_show) => {
  const internal_angle = getInternalAngle(curve, false, "green", 20);
  const next_internal_angle = getInternalAngle(curve.next, false, "yellow", 40);
  const straight_margin_angle = 7.5;
  const neighbor_len_limit = len_limit * 2;
  const theta1 = 180 - internal_angle;
  const theta2 = 180 - next_internal_angle;
  const is_straight =
    Math.abs(theta1) < straight_margin_angle &&
    Math.abs(theta2) < straight_margin_angle;
  const is_zigzag =
    curve.length < len_limit / 2 &&
    theta1 * theta2 < 0 &&
    Math.abs(theta1 - theta2) > 20 &&
    internal_angle > 60;

  const is_neighbor_long =
    curve.previous.length > neighbor_len_limit ||
    curve.next.length > neighbor_len_limit;

  if (curve.length < len_limit && !is_neighbor_long) {
    if (is_straight) {
      if (is_show) {
        new curve.path._project._scope.Path.Circle(curve.segment2.point, 4).set(
          {
            fillColor: "red",
          }
        );
      }
      return curve;
    } else if (is_zigzag) {
      if (is_show) {
        new curve.path._project._scope.Path.Circle(curve.segment2.point, 4).set(
          {
            fillColor: "orange",
          }
        );
      }
      return curve;
    }
  }
};

export const optimizePath = (paths, control_size, is_show) => {
  const opt_ll_clamp_len = 10;
  const opt_ll_length =
    control_size > opt_ll_clamp_len ? control_size : opt_ll_clamp_len;
  const opt_ll_area = opt_ll_length * opt_ll_length * 2;
  // console.log("Removal min length", opt_ll_length);
  go(
    paths instanceof paper.Path ? [paths] : paths.children,
    filterL((path) => path.area > opt_ll_area),
    eachL((path) => {
      go(
        path.curves,
        filterL((c) => {
          return getUnnecessaryCurve(c, opt_ll_length, is_show);
        }),
        eachL((c) => {
          let handle1;
          let handle2;
          if (c.previous.isStraight()) {
            handle1 = c.segment2.point.subtract(c.segment1.point);
          } else {
            handle1 = c.previous.segment2.handleOut.multiply(1.5);
          }
          if (c.next.isStraight()) {
            handle2 = c.segment2.point.subtract(c.segment2.next.point);
          } else {
            handle2 = c.next.segment2.handleIn.multiply(1.5);
          }

          c.handle_data = { handle1, handle2 };
        }),
        //Todo: merging bezier curves => into 1 bezier (what is the best algorithm?)
        eachL((c) => {
          c.segment2.remove();
          c.handle1 = c.handle_data.handle1;
          c.handle2 = c.handle_data.handle2;
        }),
        takeAll
      );
    }),
    takeAll
  );
};
